/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import DataVaxiomInsuranceBillingCenter from 'DesignSystem/DataVaxiomInsuranceBillingCenter/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/BillingCenter/Content/Options/Edit/Content/Content"
  
}) {
  return (<React.Fragment
>
<DataVaxiomInsuranceBillingCenter
  viewPath={`${viewPath}/DataVaxiomInsuranceBillingCenter`}
/>
{children}
</React.Fragment>)
}